import { IconChevronRightSmall } from "@/assets/icons/geist/IconChevronRightSmall";
import { SkeletonBlock } from "@/components/podkit/loading/Skeleton";
import type { FC } from "react";

type BreadcrumbsSkeletonProps = {
    itemsCount: number;
};

export const BreadcrumbsSkeleton: FC<BreadcrumbsSkeletonProps> = ({ itemsCount }) => {
    return (
        <ol className="flex flex-row items-center gap-2">
            {Array.from({ length: itemsCount }).map((_, index) => {
                const isLast = index === itemsCount - 1;
                return (
                    <li key={index} className="flex flex-row items-center">
                        <SkeletonBlock ready={false} className="h-8 w-24 rounded-md" />
                        {!isLast && <IconChevronRightSmall size="lg" className="ml-2 text-content-muted" />}
                    </li>
                );
            })}
        </ol>
    );
};
